export default function infrastructureOptionDirective() {
  return {
    template: require('./infrastructure-option.html'),
    scope: {
      customerId: '<',
      department: '=',
      process: '=',
      function: '=',
      infrastructureOption: '=',
      isEdit: '<',
    },
    controller: 'InfrastructureOptionController',
    controllerAs: 'infrastructureOptionVM',
    bindToController: true,
    replace: true,
  };
}
